import './wdyr.ts';
import React from 'react';
import './index.css';
import './styles/utils.scss';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom';

// We are keeping the old rendering function because
// the UiEditorProvider does not support concurrency mode.
// We can change this after migrate to SurveyApp for form filling.
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
